<template>

    <div class="d-flex gap-1 align-itens-center cursor-pointer" :class="divClasses">
        <i :class="icon"></i>
        <span>{{ text }}</span>
    </div>

</template>

<script>
export default {
    props: {
        text: {
            type: String
        },
        icon: {
            type: String
        },
        textColor:{
            type: String
        }
    },
    computed:{
        divClasses() {

            return {
                'text-info': this.textColor == 'info',
                'text-danger': this.textColor == 'danger',
                'text-success': this.textColor == 'success',
                'text-warning': this.textColor == 'warning',
                'text-light': this.textColor == 'light',
            };

        },
    }
}
</script>